import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ContactComponent } from './pages/contact/contact.component';
import { BlogComponent } from './pages/blog/blog.component';
import { PrestationComponent } from './pages/prestation/prestation.component';
import { AtelierComponent } from './pages/atelier/atelier.component';
import { PrestationsComponent } from './pages/prestations/prestations.component';
import { EvenementComponent } from './pages/evenement/evenement.component';

export const routes: Routes = [
    {path:'', component:HomeComponent},
    {path:'home', component:HomeComponent},
    {path:'contact', component:ContactComponent},
    {path:'blog', component:BlogComponent},
    {path:'prestation/:id', component:PrestationComponent},
    {path:'prestations', component:PrestationsComponent},
    {path:'atelier/:id', component:AtelierComponent},
    {path:'evenement/:id', component:EvenementComponent}
];
